"use client";

import Image from "next/image";

const features = [
  {
    iconSrc: "/price contact/percent_discount.svg",
    title: "Unlimited scale & Volume discounts",
  },
  {
    iconSrc: "/price contact/Frame 99.svg",
    title: "24/7 Priority Support & Account Manager",
  },
  {
    iconSrc: "/price contact/Frame 99 (1).svg",
    title: "Custom Models fine-tunning",
  },
];

const CALENDLY_URL = "https://calendly.com/business-dev-wlk/amz-one-step-listing-optimization-ai-user-clone";

export default function EnterpriseContact() {
  return (
    <section
        id="enterprise-contact"
        className="flex items-start justify-center bg-white py-20 px-6 md:px-[150px]"
      >
        <div className="flex flex-col md:flex-col items-start justify-center gap-16 max-w-[1200px] w-full">
          {/* Left side: Heading + Features */}
          <div className="flex flex-1 flex-col gap-10 w-full">
            <div className="flex flex-col gap-4 text-center">
              <h2
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 600,
                  fontSize: "32px",
                  lineHeight: "46px",
                  color: "#1B1C30",
                }}
              >
                Need custom pricing for enterprise?
              </h2>
              <p
                style={{
                  fontFamily: "'Hanken Grotesk', sans-serif",
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "21px",
                  color: "#4D4D5C",
                }}
              >
                Tailored solutions for high-volume platforms and large organizations. Get dedicated resources and custom models fine-tuned to your exact needs.
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-4 w-full">
              {features.map((feature) => (
                <div
                  key={feature.title}
                  className="flex flex-1 items-center gap-5 p-4 rounded-xl"
                  style={{
                    boxShadow: "0px 4px 4px rgba(7, 0, 107, 0.04)",
                    background: "white",
                  }}
                >
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(20,100,255,0.08)" }}>
                    <Image src={feature.iconSrc} alt={feature.title} width={32} height={32} />
                  </div>
                  <span
                    style={{
                      fontFamily: "'Hanken Grotesk', sans-serif",
                      fontWeight: 600,
                      fontSize: "18px",
                      lineHeight: "23px",
                      color: "#1B1C30",
                    }}
                  >
                    {feature.title}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right side: CTA Card */}
          <div
            className="flex flex-1 w-full flex-col items-start"
          >

            <iframe
              src={CALENDLY_URL}
              className="w-full rounded-lg"
              style={{ height: "700px", border: "none", }}
              title="Schedule a call"
            />
          </div>
        </div>
      </section>
  );
}